import type { LiHTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '../../utils/cn';

type BreadcrumbListItem = PropsWithChildren<LiHTMLAttributes<HTMLLIElement>>;

export const BreadcrumbListItem = ( { children, className, ...liAttributes }: BreadcrumbListItem ) => {

  return (
    <li
      className={ cn( 'font-inter text-base text-[#ABB0C7] [&_i]:text-xl [&:not(:nth-last-child(-n+3))]:hidden [&:nth-last-child(-n+1)]:hidden md:[&:not(:nth-last-child(-n+4))]:block md:[&:nth-last-child(-n+3)]:block line-clamp-1', className ) }
      { ...liAttributes }>
      { children }
    </li>
  )
}
BreadcrumbListItem.displayName = 'BreadcrumbListItem';
